import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface DropdownOption {
  text: string;
  value: string;
}

export interface MotorMasterData {
  mountingType: DropdownOption[];
  speedType: DropdownOption[];
  motorType: DropdownOption[];
  motorRegion: DropdownOption[];
}

export interface ExternalInvestigationData {
  voltages: string;
  motorRegionId: number;
  motorTypeId: number;
  motorSpeedTypeId: number;
  motorMountingTypeId: number;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const motorMasterDataApiSlice = createApi({
  reducerPath: 'motorMasterDataApi',
  baseQuery: baseQuery,
  tagTypes: ['MotorMasterData', 'ExternalInvestigationData', 'MotorNoOfPolesMasterData'],
  endpoints(builders) {
    return {
      fetchMotorMasterData: builders.query<MotorMasterData, void>({
        query: () => ({
          url: API_URLS.MOTOR.MASTER_DATA,
          method: 'GET',
        }),
        providesTags: ['MotorMasterData'],
        transformErrorResponse: transformApiError,
      }),
      fetchNoOfPolesMasterData: builders.query<number[], void>({
        query: () => ({
          url: API_URLS.MOTOR.NO_OF_POLES_MASTER_DATA,
          method: 'GET',
        }),
        providesTags: ['MotorNoOfPolesMasterData'],
        transformErrorResponse: transformApiError,
      }),
    };
  },
});

export const {
  useFetchMotorMasterDataQuery,
  useLazyFetchMotorMasterDataQuery,
  useFetchNoOfPolesMasterDataQuery,
  useLazyFetchNoOfPolesMasterDataQuery
} = motorMasterDataApiSlice;
